import { render, staticRenderFns } from "./FeNaka.vue?vue&type=template&id=86de0476&"
import script from "./FeNaka.vue?vue&type=script&lang=js&"
export * from "./FeNaka.vue?vue&type=script&lang=js&"
import style0 from "./FeNaka.vue?vue&type=style&index=0&id=86de0476&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports